// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:f5abe4ac-2f9d-4bc9-9988-2ef2d99a0831",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_gZ521giOe",
    "aws_user_pools_web_client_id": "6ia8upbp8rv1r2enr4jhp1mko8",
    "oauth": {},
    "aws_user_files_s3_bucket": "userimages-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./uncommon-client/aws-exports.js